import React, { Fragment, useEffect, useState } from "react";
import Header from "../Components/Header/Header";
import HeaderTitle from "../Components/HeaderTitle/HeaderTitle";
import DataTable from "../Components/DataTable/DataTable";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Components/Loading/Loading";
import NoData from "../Components/Loading/NoData";
import secureLocalStorage from "react-secure-storage";
import SideBar from "../Components/SideBar/SideBar";
import MetaData from "../Components/Helmet/Helmet";
import {
  clearInventoryDetails,
  getBatchesActions,
  ProductLevelConsolidatedReportActions,
} from "../Actions/ProductionActions";
import ModalContainer from "../Components/ModalContainer/ModalContainer";
import { Button } from "@material-ui/core";
import Dropdown from "../Components/Dropdown/Dropdown";
import { toast } from "react-toastify";
import PaginationRow from "../Components/Pagination/PaginationRow";
import DatePicker from "react-datepicker";
import moment from "moment";
import { filterById } from "../Middleware/CommonFun";

const TAB_ARR = [
  "Overall",
  <>
    Product Group <br />
    Wise
  </>,
  "SKU WISE",
  <>
    Style Color <br />
    Wise
  </>,
];

export const CRITICAL_ARR = [
  {
    id: 1,
    label: "True",
    value: "True",
  },
  {
    id: 0,
    label: "False",
    value: "False",
  },
];

const ProductConsolidatedReport = () => {
  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;
  const dispatch = useDispatch();

  // User Profile State
  const { user_profile } = useSelector((state) => state.userProfile);

  // Product Level Consolidated Report State
  const { productLevelConsolidated_Report, loading } = useSelector(
    (state) => state.ProductLevelConsolidatedReport
  );

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentpage, setCurrentPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(0);

  const [isActiveTab, setIsActiveTab] = useState(1);

  const [isOpened, setIsOpened] = useState(false);

  const handleSidebar = () => {
    setIsOpened(!isOpened);
  };

  const [activeProduct, setActiveProduct] = useState("Product Group");
  const [activeProductListening, setActiveProductListening] =
    useState("product_group");

  const handleRefreshBeforeLogout = () => {
    dispatch(clearInventoryDetails());
  };

  console.log(
    "PRODUCT LEVEL CONSOLIDATED REPORT: ",
    productLevelConsolidated_Report?.data?.data
  );

  // Modal Code starts here
  const [isIndex, setIsIndex] = useState(null);

  const handleModal = (index, id) => {
    setIsIndex(index);
  };

  const closeModal = () => {
    setIsIndex(null);
  };

  const renderModal = () => {
    if (isIndex !== null) {
      return (
        <ModalContainer
          Isopen={true}
          index={isIndex}
          closeModal={closeModal}
          onData={closeModal}
        />
      );
    }
    return null;
  };
  // Modal Code ends here

  const ProductConsolidatedHeader = [
    { value: "S.No" },
    { value: "Date" },
    {
      value: (
        <>
          Product <br />
          Group
        </>
      ),
    },
    ...(productLevelConsolidated_Report?.list?.operation_types
      ? Object.entries(
          productLevelConsolidated_Report.list.operation_types
        ).map(([id, name]) => ({
          id,
          value: name,
        }))
      : []),
  ];

  console.log("PRODUCT CONSOLIDATED REPORT: ", ProductConsolidatedHeader);

  const [ProductList, setProductList] = useState([]);
  // Pagination

  useEffect(() => {
    if (
      productLevelConsolidated_Report &&
      productLevelConsolidated_Report?.status === 1
    ) {
      const totalCount = productLevelConsolidated_Report?.data?.total_count;
      console.log("TOTAL COUNT:", totalCount);
      console.log("PAGE SIZE:", pagesize);

      console.log(
        "PRODUCT LEVEL CONSOLIDATED REPORT: ",
        productLevelConsolidated_Report?.list?.products
      );

      let productsList = Object.entries(
        productLevelConsolidated_Report?.list?.products || {}
      ).map(([key, value]) => ({
        value: key,
        label: value,
      }));
      setProductList(productsList);

      const totalPages = Math.ceil(totalCount / pagesize);
      console.log("TOTAL PAGES: Logic: ", totalPages);
      setTotalPage(totalPages);
    }
  }, [productLevelConsolidated_Report]);

  console.log("TOTAL PAGES: ", totalPage);

  // Batches State
  const { getBatches, loading: batchLoading } = useSelector(
    (state) => state.Batches
  );

  const [productGroupList, setProductGroupList] = useState([]);

  useEffect(() => {
    dispatch(getBatchesActions("get_batches", null, 1, 10, token));
  }, [dispatch, token]);

  useEffect(() => {
    if (getBatches && getBatches?.status === 1) {
      // const totalPages = Math.ceil(getBatches?.total_count / pagesize);
      // setTotalPage(totalPages);
      // console.log("TOTAL PAGES: Logic: ", totalPages);
      // or this if you intended to store total_count instead
      // setTotalPage(getBatches?.total_count);

      let product_group = Object.entries(
        getBatches?.list?.product_groups || {}
      ).map(([key, value]) => ({
        value: key,
        label: value,
      }));
      setProductGroupList(product_group);

      // let products = Object.entries(getBatches?.list?.products || {}).map(
      //   ([key, value]) => ({
      //     value: key,
      //     label: value,
      //   })
      // );
      // setProductList(products);
    }
  }, [getBatches]);

  const [date, setDate] = useState(null);
  const [product_group_id, setProductGroupId] = useState("");
  const [product_id, setProduct_id] = useState("");
  const [show_critical_node_only, setShowCriticalNodeOnly] = useState("");

  const handleDate = (val) => {
    setCurrentPage(1);
    setDate(val);
  };

  const handleProductGroup = (val) => {
    setProductGroupId(val?.value);
  };

  const handleProduct = (val) => {
    setProduct_id(val?.value);
  };

  const handleNode = (val) => {
    console.log("VAL: ", val);
    setShowCriticalNodeOnly(val?.id);
  };

  useEffect(() => {
    dispatch(
      ProductLevelConsolidatedReportActions(
        "product_level_consolidated_date_wise_report",
        token,
        activeProductListening,
        currentpage,
        pagesize,
        product_group_id,
        product_id,
        date ? moment(date).format("YYYY-MM-DD") : "",
        show_critical_node_only
      )
    );
  }, [
    dispatch,
    token,
    currentpage,
    pagesize,
    product_group_id,
    product_id,
    date,
    show_critical_node_only,
    activeProductListening,
  ]);

  // console.log("")

  const handleClearFilter = () => {
    setCurrentPage(1);
    setShowCriticalNodeOnly("");
    setProductGroupId("");
    setProduct_id("");
    setDate(null);
  };

  const handleTabChange = (i) => {
    setCurrentPage(1);
    setShowCriticalNodeOnly("");
    setProductGroupId("");
    setProduct_id("");
    setDate(null);
    // console.log("I VAKYE: ", i);
    let idx =
      i === 1
        ? "product_group"
        : i === 2
        ? "product"
        : i === 3
        ? "category_style_color"
        : i === 0
        ? "overall"
        : null;

    let activeProduct =
      i === 1
        ? "Product Group"
        : i === 2
        ? "Product"
        : i === 3
        ? "Category Style Color"
        : i === 0
        ? "Overall"
        : null;
    setActiveProduct(activeProduct);
    setActiveProductListening(idx);
    if (idx === null) {
      toast.error("Something Went Wrong");
      return;
    }
    setIsActiveTab(i);
    dispatch(
      ProductLevelConsolidatedReportActions(
        "product_level_consolidated_date_wise_report",
        token,
        idx,
        currentpage,
        null,
        null,
        null,
        null
      )
    );
  };

  // console.log("PRODUCT: ", productLevelConsolidated_Report?.data?.data);
  // utility to build header rows
  // const buildHeaders = (operationTypeMap) => {
  //   const mainRow = [];
  //   const subRow = [];

  //   Object.values(operationTypeMap).forEach((category) => {
  //     const nodes = category.nodes || {};
  //     const colSpan = Object.keys(nodes).length;

  //     // first row: main category
  //     mainRow.push({
  //       label: category.name,
  //       colSpan: colSpan,
  //     });

  //     // second row: child operations
  //     Object.entries(nodes).forEach(([id, name]) => {
  //       subRow.push({
  //         id,
  //         label: name,
  //       });
  //     });
  //   });

  //   return { mainRow, subRow };
  // };

  // const operationTypeMap =
  //   productLevelConsolidated_Report?.list?.process_nodes || {};

  // const { mainRow, subRow } = buildHeaders(operationTypeMap);

  // operationTypeMap = productLevelConsolidated_Report?.list?.operation_types
  function buildHeaders(operationTypeMap = {}) {
    const mainRow = [];
    const subRow = [];
    const opOrder = [];

    // Define custom order for main categories
    const mainOrder = ["Fresh", "Alter", "Stained", "Mending"];

    // Define custom order for sub categories (node names)
    const subOrder = [
      "Cutting ",
      "Distribution",
      "Stitching",
      "Overlock",
      "Folding",
      "Production final scanning ",
      "Thread Cutting",
      "Kaaj and Button",
      "Steam Press",
      "Checking",
      "Packing",
      "Fresh Final Step",
      "Stain removal ",
      "Alter Distribution",
      "Alter Stitching ",
      "Alter Final Clearing ",
      "Mending segregation",
      "Mending making",
      "Mending final clearance",
      "Stained Final clearance ",
    ];

    // Sort helper for categories
    const sortByMainOrder = (a, b) =>
      mainOrder.indexOf(a[1]?.name || a[0]) -
      mainOrder.indexOf(b[1]?.name || b[0]);

    // Sort helper for nodes
    const sortBySubOrder = (a, b) =>
      subOrder.indexOf(a[1]) - subOrder.indexOf(b[1]);

    // Sort categories first
    const sortedCategories =
      Object.entries(operationTypeMap).sort(sortByMainOrder);

    sortedCategories.forEach(([catKey, cat]) => {
      const nodes = cat?.nodes || {};

      // Sort nodes inside each category
      const nodeEntries = Object.entries(nodes).sort(sortBySubOrder);

      mainRow.push({
        label: cat?.name || catKey,
        colSpan: nodeEntries.length || 1,
      });

      nodeEntries.forEach(([id, name]) => {
        subRow.push({ id, label: name });
        opOrder.push(String(id));
      });
    });

    return { mainRow, subRow, opOrder };
  }

  const { mainRow, subRow, opOrder } = buildHeaders(
    productLevelConsolidated_Report?.list?.process_nodes
  );

  console.log("MAIN ROW", mainRow);
  console.log("SUB ROW: ", subRow);
  // console.log("OP ORDER: ", opOrder);

  console.log("TABLE ROW: ", productLevelConsolidated_Report?.data?.data);

  return (
    <Fragment>
      <MetaData title={`Product group level consolidated master data add`} />

      <SideBar isOpened={isOpened} handleSidebar={handleSidebar} />

      {/* Header Component starts here */}
      <Header
        handleRefreshBeforeLogout={handleRefreshBeforeLogout}
        profile_image={user_profile && user_profile?.data?.profile_image}
        handleSidebar={handleSidebar}
      />
      {/* Header Component starts here */}

      {/* SideBar component starts here */}
      {/* SideBar component ends here */}
      <div className="gantt-chart-wrapper-container">
        {/* Heading Component starts here */}
        <HeaderTitle
          link={false}
          title={"Product group level consolidated master data add"}
        />
        <div className="container">
          {/* Tab Module Component starts here */}
          <div className="product__level_grid_row">
            {TAB_ARR &&
              TAB_ARR?.map((i, index) => (
                <div key={index}>
                  <Button
                    className={`${
                      isActiveTab === index ? "active__botsTab" : ""
                    }`}
                    onClick={() => handleTabChange(index)}
                  >
                    {i}
                  </Button>
                </div>
              ))}
          </div>
          {/* Tab Module Component ends here */}

          {/* Dropdown Component starts here */}
          <div className="dropdown__grid__row mobile__grid__dropd__row">
            <div>
              <Dropdown
                label="Product Group"
                placeholder="Product Group"
                dropdown={productGroupList}
                onData={(val) => {
                  setCurrentPage(1);
                  handleProductGroup(val);
                }}
                value={filterById(productGroupList, product_group_id)}
              />
            </div>
            <div>
              <Dropdown
                label="Product"
                placeholder="Product"
                dropdown={ProductList}
                onData={(val) => {
                  setCurrentPage(1);
                  handleProduct(val);
                }}
                value={filterById(ProductList, product_id)}
              />
            </div>
            <div>
              <Dropdown
                label="Critical Mode"
                placeholder="Critical Mode"
                dropdown={CRITICAL_ARR}
                onData={(val) => {
                  setCurrentPage(1);
                  handleNode(val);
                }}
                value={filterById(CRITICAL_ARR, show_critical_node_only)}
              />
            </div>
            <div>
              <label htmlFor="" className="label">
                Date
              </label>
              <DatePicker
                className="date-picker"
                selected={date}
                placeholderText="Date"
                onChange={(date) => handleDate(date)}
              />
            </div>
            <div className="clear__filter">
              <Button onClick={handleClearFilter}>Clear Filter</Button>
            </div>
          </div>
          {/* Dropdown Component ends here */}

          {/* 30/70 grid container row starts here */}
          <div>
            {/* left row container */}
            {/* Table container starts here */}
            <div className="production-container manufacturing-container">
              <div className="table-wrapper-pagination product-consolidated-report">
                <div className="table-container-pagination">
                  {loading ? (
                    <Loading
                      loading={loading}
                      color={"rgba(1, 18, 34, 1)"}
                      size={42}
                    />
                  ) : (
                    <>
                      {productLevelConsolidated_Report &&
                      productLevelConsolidated_Report?.data?.data?.length >
                        0 ? (
                        <DataTable
                          items_per_page={10}
                          page={1}
                          // header={ProductConsolidatedHeader}
                          header={{ mainRow, subRow }}
                          productConsolidatedReport={
                            productLevelConsolidated_Report?.data?.data || []
                          }
                          operationTypeMap={
                            productLevelConsolidated_Report?.list
                              ?.operation_types || {}
                          }
                          activeProduct={activeProduct}
                        />
                      ) : (
                        <NoData title={"No Results Found"} />
                      )}
                    </>
                  )}
                </div>
                <PaginationRow
                  totalRecords={totalRecords}
                  uniqueKey={`product_Consolidated-${currentpage}`}
                  currentpage={currentpage}
                  setCurrentPage={setCurrentPage}
                  totalPage={totalPage}
                  pagesize={pagesize}
                  setPageSize={setPageSize}
                />
              </div>
            </div>
            {/* Table container ends here */}
            {/* right row container */}
          </div>
          {/* 30/70 grid container row ends here */}
        </div>
      </div>
      {renderModal()}
    </Fragment>
  );
};

export default ProductConsolidatedReport;
